/* global $ */ /* Bliss */

export class Navigation {
  constructor() {
    this.header = $(".header")
    this.navigationToggle = $(".header__toggle", this.header)
    this.isOpen = false

    this.setListeners()
  }

  setListeners() {
    this.navigationToggle.addEventListener("click", () => {
      this.toggleMobileNavigation()
    })
  }

  toggleMobileNavigation() {
    if (this.isOpen) {
      this.closeMobileNavigation()
    } else {
      this.openMobileNavigation()
    }
  }

  openMobileNavigation() {
    this.isOpen = true
    this.header.classList.add("open")
  }

  closeMobileNavigation() {
    this.isOpen = false
    this.header.classList.remove("open")
  }
}
